import { styled } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';
import { Check } from '@mui/icons-material';
import { StepLabel } from '@mui/material';

export const OrderStepConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.customTheme.palette.primary,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.customTheme.palette.primary,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.customTheme.palette.border,
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const OrderStepIconRoot = styled('div')<{
  ownerState: {
    active?: boolean;
  };
}>(({ theme, ownerState }) => ({
  backgroundColor: theme.customTheme.palette.border,
  zIndex: 1,
  color: theme.customTheme.palette.text.primary,
  width: 24,
  height: 24,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    backgroundColor: theme.customTheme.palette.primary,
    color: theme.customTheme.palette.text.button.contained,
  }),
  '& .StepIcon-completedIcon': {
    color: theme.customTheme.palette.text.button.contained,
    zIndex: 1,
    fontSize: 18,
  },
  '& .StepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));

export function OrderStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  return (
    <OrderStepIconRoot ownerState={{ active }} className={className}>
      {completed ? <Check className="StepIcon-completedIcon" /> : <div className="StepIcon-circle" />}
    </OrderStepIconRoot>
  );
}

export const OrderStepLabel = styled(StepLabel)(({ theme }) => ({
  '& .MuiStepLabel-label': {
    color: theme.customTheme.palette.text.primary,
  },
  '& .MuiStepLabel-label.Mui-active': {
    color: theme.customTheme.palette.text.primary,
  },
  '& .MuiStepLabel-label.Mui-completed': {
    color: theme.customTheme.palette.text.primary,
  },
  '& .MuiStepLabel-iconContainer': {
    paddingRight: '4px',
  },
}));
